<template>
  <ElBadge class="new-badge" :value="$t('NEW')" />
</template>

<script>
export default {
  name: 'NewBadge',
};
</script>

<style lang="scss">
.new-badge {
  .el-badge__content {
    font-size: 0.5rem;
    height: auto;
    line-height: normal;
    padding: 0 0.3rem;
  }
}
</style>
